function formatSeatLabelText(name) {
    var parts = name.trim().split(' ');
    var first = parts[0] || '';
    var rest = parts.slice(1).join(' ') || '';
    return (first && rest) ? first + '\n' + rest : name;
}

function createOptimizedSeatLabel(personName, boxSize, radiusSize, fill) {
    var textContent = formatSeatLabelText(personName);

    var availableWidth = radiusSize * 1.8;
    var availableHeight = radiusSize * 1.6;
    var consistentFontSize = Math.max(8, Math.floor(boxSize * 0.12));

    var text = new fabric.Textbox(textContent, {
        fontFamily: 'Work Sans, serif',
        textAlign: 'center',
        width: availableWidth,
        height: availableHeight,
        originX: 'center',
        originY: 'center',
        left: radiusSize,
        top: radiusSize,
        fixedWidth: availableWidth,
        fontSize: consistentFontSize,
        wordWrap: 'break-word',
        splitByGrapheme: true,
        fill: fill,
        fontWeight: '600',
        lineHeight: 1.1,
        selectable: false,
        evented: false
    });

    if (text.width > availableWidth || text.height > availableHeight) {
        var scaleX = availableWidth / text.width;
        var scaleY = availableHeight / text.height;
        var scale = Math.min(scaleX, scaleY, 1);

        text.set({
            fontSize: consistentFontSize * scale,
            width: availableWidth,
            height: availableHeight
        });
    }

    return text;
}

module.exports = {
    createOptimizedSeatLabel: createOptimizedSeatLabel,
    formatSeatLabelText: formatSeatLabelText
};
